import { useMutation } from '@tanstack/react-query';

import { postGooglePayment } from '../api/payment.api';

interface PostGooglePaymentParams {
    orderId: string | undefined;
    loyaltyId: number;
    paymentRequest: Record<string, unknown>;
}

export const usePostGooglePayment = () => {
    return useMutation({
        mutationFn: ({ orderId, loyaltyId, paymentRequest }: PostGooglePaymentParams) =>
            postGooglePayment(orderId, loyaltyId, paymentRequest),
    });
};
